import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newLabour({ state }) {
    Vue.swal
      .fire({
        title: "KINDLY COUNTER CHECK!",
        text:
          "IF YOU HAVE ENTERED THE RIGHT DETAILS AS PER LABOUR DONE PROCEED TO CLICK OK, IF NOT KINDLY CLICK CANCEL AND COUNTER CHECK THE DATA BEFORE ENTER",
        type: "warning",
        showCancelButton: true
      })
      .then(result => {
        if (result.value) {
          let labourDetails = {
            labour_total: $(".labour_total").val(),
            labour_date: $(".labour_date").val(),
            jobcard_id: $('.jobcard_id').val(),
            truck_id: $('.truck_id').val(),
            labour_item: state.labour_item
          };
          $(".creatingLabour").hide();
          $(".creatingLabourLoader").show();
          baseurl.post(rt.newLabour, labourDetails).then(res => {
            $(".creatingLabour").show();
            $(".creatingLabourLoader").hide();

            //checking for response codes from backend api

            if (res.data.code === 200) {
              //success code
              suc.laboursCreateSuccess();
              $(".form-control").val("");
              router.push("/managelabourcharges");
            } else if (res.data.code === 402) {
              //validation code
              ers.validateErrors();
            } else if (res.data.code === 404) {
              //error on creating data
              ers.errorCreatingLabour();
            } else if (res.data.code === 405) {
              //no permission to create
              ers.noPermissionToCreate();
              router.push("/dashboard");
            } else if (res.data.code === 506) {
              //session expired
              ses.sessionComplete();
            }
          });
        }
      });
  },

  loadLabours({ commit }) {
    baseurl.get(rt.laodLabours).then(res => {
      $(".laboursLoader").hide();

      //checking for response codes from backend api

      if (res.data.code === 200) {
        //committing mutations
        commit("STORE_LABOURS", res.data.labours);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingLabour();
      } else if (res.data.code === 405) {
        //no permission to read
        ers.noPermissionToRead();
        commit("STORE_LABOURS", []);
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  editLabour({ commit }, id) {
    let labourDetails = {
      labour_id: id
    };
    baseurl.post(rt.editLabour, labourDetails).then(res => {
      //checking for response codes from backend api

      if (res.data.code === 200) {
        commit("STORE_LABOUR_ITEMS", res.data.labour_items);
        router.push("/editlabour");
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingLabour();
      } else if (res.data.code === 405) {
        //no permission to  read
        ers.noPermissionToRead();
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  updatingLabour({ state }) {
    let labourDetail = {
      labour_total: $(".labour_total").val(),
      labour_items: state.labour_items
    };
    $(".updatingLabour").hide();
    $(".updatingLabourLoader").show();
    baseurl.post(rt.updateLabour, labourDetail).then(res => {
      $(".updatingLabour").show();
      $(".updatingLabourLoader").hide();

      //checking for response codes from backend api

      if (res.data.code === 200) {
        suc.laboursUpdateSuccess();
        setTimeout(() => {
          router.push("/managelabourcharges");
        }, 3000);
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 404) {
        ers.errorUpdatingLabour();
      } else if (res.data.code === 405) {
        ers.noPermissionToUpdate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/labours/actions.js